import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueFieldSchemesRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-view',
	path: '/jira/settings/issues/screen-schemes',
};
